module.exports = __webpack_public_path__ + "static/img/far1.5cb7240a.png";